export default "../css/87ca550c455e71127ce23fdd485a2f1e.ttf";